/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*******************************************!*\
  !*** ./src/js/product-recently-viewed.js ***!
  \*******************************************/
/*
BG: Uses localStorage to store the products the user visits, and displays it back to the customer in a recently viewed section.
*/
var recentlyViewedProducts = function recentlyViewedProducts() {
  var recentlyViewed = document.querySelector('.js-recently-viewed-products');
  var recentlyViewed_arrows = document.querySelectorAll('.collection-recently-viewed .flickity-button');
  var maxProducts = 6;
  var savedRecentProducts = JSON.parse(localStorage.getItem("recentProducts")); //by default, we assume the prodict array is empty. 

  var productArray = [];
  var flickityPresent = false; //We planning on using flickity?, we check to see if the inline attribute is present.

  if (recentlyViewed.hasAttribute('data-flickity')) {
    flickityPresent = true;
  } //if localstorage exists, retrieve the list and output it


  if (savedRecentProducts) {
    //BG: if array is greater than the maxProducts, then delete the first item in the array
    if (savedRecentProducts.length > maxProducts) {
      savedRecentProducts.shift();
    } //update the product array to be the array stored in localStorage.


    productArray = savedRecentProducts;

    if (productArray.length < 5) {
      recentlyViewed.classList.add('hide-arrows');
    }

    productArray.forEach(function (productHandle, index) {
      //console.log(window.Shopify.routes.root + `products/${productHandle}?view=card`);
      //using that productHandle, get the product markup.
      fetch(window.Shopify.routes.root + "products/".concat(productHandle, "?view=card")).then(function (response) {
        return response.text();
      }).then(function (html) {
        //BG: we get the first 26 characters of the response, to check if we're returning what we expect (the card product template) if the product no longer exists, it will 404, so we will return markup we don't intend, therefore we check to see if the preview does include what we expect, if it does, we show it, if it doesn't we remove it from the array.
        var preview = html.slice(0, 26);

        if (preview.includes("product-card")) {
          var flickitySlider = recentlyViewed.querySelector('.flickity-slider');

          if (!!flickitySlider) {
            flickitySlider.innerHTML += html;
          } else {
            recentlyViewed.innerHTML += html;
          } //if last product, and we're using flickity....


          if (flickityPresent && flickitySlider) {
            //after a breif delay, re-init flickity.
            setTimeout(function () {
              var flkty = Flickity.data('.js-recently-viewed-products');
              flkty.reloadCells();
              flkty.resize();
            }, 1000);
          }
        } else {
          //if the preview doesn't include the product card, we're not returning what we expect, remove it from the array.
          var removeProd = productArray.indexOf(productHandle);

          if (removeProd > -1) {
            productArray.splice(removeProd, 1);
          } //BG: Update localStorage, so we don't try and show it again.


          localStorage.setItem("recentProducts", JSON.stringify(productArray));
        }
      })["catch"](function (error) {
        console.error('Error:', error);
      });
    });
  } // if the recently viewed section has the product handle, add this product to the array.


  if (recentlyViewed.hasAttribute('data-product-handle')) {
    var productHandle = recentlyViewed.getAttribute('data-product-handle'); //BG: only add the product to the array, if it doesn't already exist

    if (productHandle && productHandle.trim() !== '' && productArray.indexOf(productHandle) === -1) {
      productArray.push(productHandle);
    } //BG: Update localStorage


    localStorage.setItem("recentProducts", JSON.stringify(productArray));
  }

  setTimeout(function () {
    productMatchingColours();
  }, 1000);
}; //check if the section exists, if so, run the function.


if (!!document.querySelector('.js-recently-viewed-products')) {
  recentlyViewedProducts();
} // ---------------------------------------------------------------------------
// Product Swatches - Colours
// ---------------------------------------------------------------------------

/**
 * BG: Build the Colour Swatch based on the returned result from the ajax
 */


function outputColourSwatchProductsPage(json, currentProductID, productColoursContainer) {
  var markup = '<div class="product-colours">';
  var colourArray = [];
  var orderedProducts = []; // Convert the products object to an array to allow sorting

  var productsArray = Object.values(json.products); // Sort the products array by size numerically

  productsArray.sort(function (a, b) {
    return parseInt(a.size) - parseInt(b.size);
  }); // Loop through the sorted products array and add each product to the orderedProducts array

  for (var i = 0; i < productsArray.length; i++) {
    var productID = parseInt(productsArray[i]['id']);
    var productColour = productsArray[i]['colour'];
    var productURL = productsArray[i]['url'];
    var productSize = productsArray[i]['size'];
    var arrayCheck = colourArray.findIndex(function (obj) {
      return obj.colour === productColour;
    });

    if (productID === currentProductID) {
      var selectedProductColour = productColour;
    }

    if (arrayCheck == -1) {
      colourArray.push({
        "colour": productColour,
        "url": productURL,
        "size": productSize
      });
    }

    orderedProducts.push({
      "id": productID,
      "colour": productColour,
      "url": productURL,
      "size": productSize
    });
  }

  colourArray.forEach(function (colour) {
    // Add option product to the list and select markup
    var classes = 'btn-colour-swatch ' + colour.colour.toLowerCase() + ' h-6 w-6 rounded-full border border-gray-100 mr-2.5 cursor-pointer';

    if (classes.includes(selectedProductColour)) {
      classes += ' current'; // add the 'current' class if it contains the selected product colour
    }

    markup += '<a href="' + colour.url + '" class="' + classes + '"></a>';
  }); //close list and select markup

  markup += '</div>';
  var titleElement = productColoursContainer.querySelector('.title');
  titleElement.insertAdjacentHTML('afterend', markup);
}

function productMatchingColours() {
  var productColoursContainers = document.querySelectorAll('.product-card-colours-container');

  if (productColoursContainers) {
    productColoursContainers.forEach(function (productColoursContainer) {
      var productColourTag = productColoursContainer.getAttribute('data-colour-group');
      var currentProductID = parseInt(productColoursContainer.getAttribute('data-current-product-id'));

      if (productColourTag) {
        var xhr = new XMLHttpRequest();

        xhr.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            var data = this.responseText;

            if (data) {
              try {
                var json = JSON.parse(data);
              } catch (e) {
                var json = null;
              }
            }

            if (json) {
              outputColourSwatchProductsPage(json, currentProductID, productColoursContainer);
            }
          }
        };

        xhr.open('GET', '/collections/all/' + productColourTag + '?view=swatch', true);
        xhr.send();
      }
    });
  }
}
/******/ })()
;